import { stringify } from 'qs';

import { OVERLAY_BASE_URL, OVERLAY_CLICK_COUNT, OVERLAY_VISIT_COUNT } from '../../constants/apis';
import type {
  OverlaysClickCountRequest,
  OverlaysClickCountResponse,
  OverlaysGetRequest,
  OverlaysGetResponse,
  OverlaysVisitCountRequest,
  OverlaysVisitCountResponse,
} from '../../types/overlays';
import { ApiManager } from '../axios-config';

export const getOverlays = async (params: OverlaysGetRequest) => {
  const response = await ApiManager.get<OverlaysGetResponse>(`${OVERLAY_BASE_URL}/v2`, {
    params,
    paramsSerializer: (params) => {
      return stringify(params);
    },
  });
  return response.data;
};

export const postOverlaysClickCount = async (params: OverlaysClickCountRequest) => {
  await ApiManager.post<OverlaysClickCountResponse>(
    `${OVERLAY_CLICK_COUNT}?id=${params.id}&session=${params.session}`,
  );
};

export const postOverlaysVisitCount = async (params: OverlaysVisitCountRequest) => {
  await ApiManager.post<OverlaysVisitCountResponse>(
    `${OVERLAY_VISIT_COUNT}?id=${params.id}&session=${params.session}`,
  );
};
